import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

import { ConfirmationDialog } from './confirmation-dialog';

const element = document.createElement('div');
const body = document.querySelector('body');
body.appendChild(element);

export function showAnswersDialog(options) {
  return new Promise(resolve => {
    const { content, title, renderActions } = options;

    const answer = (value) => {
      unmountComponentAtNode(element);
      resolve(value);
    };

    const component = (
      <ConfirmationDialog
        content={content}
        onClose={answer}
        open
        title={title}
      >
        {renderActions(answer)}
      </ConfirmationDialog>
    );

    render(component, element);
  });
}
